module.exports = __webpack_public_path__ + "img/Retail14.3a28965b.png";